import {ServiceOrderEvaluationStatus} from "./ServiceOrderEvaluationStatus";

export const ServiceOrderEvaluationStatusColors: Record<ServiceOrderEvaluationStatus, "warning" | "success"> = {
  [ServiceOrderEvaluationStatus.IN_PROGRESS]: "warning",
  [ServiceOrderEvaluationStatus.COMPLETED]: "success",
};
